import React, { useEffect } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import useMount from '../../common/hooks/useMount';

import PaginatedTable from '../../common/components/Table/PaginatedTable';
import { fetchEventAuditLogs, resetEventAuditLogs } from '../../redux/actions/eventsActions';
import Portlet from '../../common/components/Portlet';

const ITEMS_PER_PAGE = 10;

const mapStateToProps = state => ({
  currState: state.eventsReducer,
  auditLogs: state.eventsReducer.auditLogs,
  limit: state.eventsReducer.auditLogsLimit,
  offset: state.eventsReducer.auditLogsOffset,
  totalCount: state.eventsReducer.auditLogsTotalCount,
  isFetchingAuditLogs: state.eventsReducer.isFetchingAuditLogs,
  isFetchAuditLogsError: state.eventsReducer.isFetchAuditLogsError,
});

const mapDispatchToProps = {
  fetchEventAuditLogs,
  resetEventAuditLogs,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  currentPage: (stateProps.offset / stateProps.limit) + 1,

  onTableChange(pagination) {
    const pageZeroBased = pagination.current - 1;

    dispatchProps.fetchEventAuditLogs({
      eventId: ownProps.eventId,
      limit: ITEMS_PER_PAGE,
      offset: pageZeroBased * ITEMS_PER_PAGE,
      orderBy: 'created_at',
    });
  },
});

const columns = [
  {
    title: 'Admin',
    dataIndex: 'admin_user_first_name',
    render: (text, record) => (
      record.admin_sub === 'system'
        ? 'System'
        : `${record.admin_user_first_name || ''} ${record.admin_user_last_name || ''}`
    ),
  },
  {
    title: 'Time',
    dataIndex: 'created_at',
    render: record => moment(record).format('MM/DD/YY H:mm'),
  },
  {
    title: 'Activity',
    dataIndex: 'activity',
  },
  {
    title: 'Comment',
    dataIndex: 'comment',
    render: text => (
      <div
        style={{
          wordWrap: 'break-word',
          wordBreak: 'break-word',
          maxWidth: '500px',
        }}
      >
        {text}
      </div>
    ),
  },
];

function EventAuditLog(props) {
  useMount(() => {
    props.fetchEventAuditLogs({
      eventId: props.eventId, limit: ITEMS_PER_PAGE, offset: 0, orderBy: 'created_at',
    });
  });

  useEffect(() => {
    if (props.isFetchAuditLogsError) {
      props.resetEventAuditLogs();
    }
  }, [props.isFetchAuditLogsError]);

  if (props.isFetchAuditLogsError) {
    return <Redirect to={props.originPath} />;
  }

  return (
    <Portlet
      config={props.portletConfig}
      activeTab={props.activeTab}
      handleTabClick={props.onTabClick}
    >
      <div className="mt-5 mb-5 col-lg-12 datatable datatable-default">
        <PaginatedTable
          columns={columns}
          dataSource={props.auditLogs}
          rowKey={record => record.audit_log_id}
          currentPage={props.currentPage}
          getPage={() => {}}
          loading={props.isFetchingAuditLogs}
          limit={ITEMS_PER_PAGE}
          totalCount={props.totalCount}
          onColumnChange={props.onTableChange}
        />
      </div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link to={props.originPath}>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => {}}
        >
          BACK
        </button>
      </Link>
    </Portlet>
  );
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EventAuditLog);



// WEBPACK FOOTER //
// ./src/js/views/event/EventAuditTrail.jsx